module.exports = __webpack_public_path__ + "static/media/man-and-dog.fc961028.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/man-and-dog.jpg
// module id = 287
// module chunks = 0